// src/app/core/store/profile/profile.reducer.ts

import { createReducer, on } from '@ngrx/store';
import {
  ProfileState,
  initialProfileState,
  AsyncSlice,
  CacheEntry,
  PROFILE_TTL,
  isCacheValid,
} from './profile.state';
import { ProfileActions } from './profile.actions';
import { UserProfile } from '@core/services/account.service';

function setLoading<T>(slice: AsyncSlice<T>): AsyncSlice<T> {
  return { ...slice, loading: true, error: null };
}

function setSuccess<T>(slice: AsyncSlice<T>, data: T, ttlMs: number): AsyncSlice<T> {
  const cache: CacheEntry<T> = { data, loadedAt: Date.now(), ttlMs };
  return { data, loading: false, loaded: true, error: null, cache };
}

function setFailure<T>(slice: AsyncSlice<T>, error: string): AsyncSlice<T> {
  return { ...slice, loading: false, error };
}

export const profileReducer = createReducer(
  initialProfileState,

  on(ProfileActions.load, (state, { forceReload }): ProfileState => {
    if (!forceReload && isCacheValid(state.profile.cache)) return state;
    return { ...state, profile: setLoading(state.profile) };
  }),

  on(ProfileActions.success, (state, { data }): ProfileState => ({
    ...state,
    profile: setSuccess(state.profile, data, PROFILE_TTL),
  })),

  on(ProfileActions.failure, (state, { error }): ProfileState => ({
    ...state,
    profile: setFailure(state.profile, error),
  })),

  on(ProfileActions.clear, (state): ProfileState => ({
    ...state,
    profile: { data: null, loading: false, loaded: false, error: null, cache: null },
  })),
);
